import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { NotificationService } from './notification.service';
import { AuthService } from './auth.service';

/**
 * Intercepteur global qui convertit toute erreur HTTP en notification toastr
 * lisible et redirige vers /authentication/login en cas de 401.
 *
 * Les requêtes peuvent désactiver l'affichage automatique du toast
 * en ajoutant le header `X-Skip-Error-Toast: true` (utile pour les appels
 * où le composant veut gérer son propre message).
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const notif = inject(NotificationService);
  const router = inject(Router);
  const auth = inject(AuthService);

  const skip = req.headers.get('X-Skip-Error-Toast') === 'true';
  const cleanedReq = skip
    ? req.clone({ headers: req.headers.delete('X-Skip-Error-Toast') })
    : req;

  return next(cleanedReq).pipe(
    catchError((err: HttpErrorResponse) => {
      if (!skip) {
        notif.fromHttpError(err);
      }

      if (err.status === 401 && !req.url.includes('/x-auth/login')) {
        // Déléguer entièrement à AuthService : nettoie les timers, le storage et le state
        auth.logout();
      }

      return throwError(() => err);
    }),
  );
};
